var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtruderMotor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 227,
    viewBox: "0 0 259 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.72 61H49.7226V109.212C49.7226 125.652 45.6642 141.835 37.899 156.318L0 226.985H258.729V61H258.72Z",
    fill: "#6A5DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.342 182.486L122.305 172.568L79.2922 139.637L101.326 95.2338C105.205 88.8158 112.077 84.8002 119.568 84.5771L169.342 85.2035V182.486Z",
    fill: "url(#paint0_radial_3293_34496)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.291 139.618L103.685 91.989C106.036 87.4072 110.755 84.5156 115.903 84.5156H227.163C237.511 84.5156 244.135 95.5241 239.296 104.679L193.357 191.451C190.98 195.939 186.304 198.762 181.224 198.762H70.153C59.7194 198.762 53.1126 187.607 58.0977 178.452L79.2824 139.627H79.2996L79.291 139.618Z",
    fill: "#9EACAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6632 132.414L95.4229 160.18L104.175 169.875L169.342 170.536V190.691H99.5501H77.1384V143.852L82.7499 132.431L95.6632 132.414Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.536 158.45C112.874 158.45 115.585 148.522 115.585 136.27C115.585 124.017 112.874 114.09 109.536 114.09C106.198 114.09 103.487 124.017 103.487 136.27C103.487 148.522 106.198 158.45 109.536 158.45Z",
    fill: "url(#paint1_linear_3293_34496)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.587 105.94H96.5882L82.7483 132.445L95.6615 132.428L109.587 105.94Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2819 190.687H77.1384V143.847L82.7414 132.427H95.6546",
    fill: "#DED9D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2819 190.687H77.1384V143.847L82.7414 132.427H95.6546",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.963 190.695H99.5449",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.022 170.557L118.932 160.467C118.512 160.046 118.271 159.471 118.271 158.871V108.299C118.271 107.046 117.267 106.042 116.015 106.042H110.266C109.408 106.042 108.627 106.522 108.25 107.295L95.6709 132.452C95.5079 132.761 95.4307 133.113 95.4307 133.456V160.218C95.4307 160.818 95.6709 161.385 96.0914 161.814L104.183 169.905C104.603 170.325 105.178 170.566 105.779 170.566H169.35V190.729H153.184",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.022 170.557L118.932 160.467C118.512 160.046 118.271 159.471 118.271 158.871V108.299C118.271 107.046 117.267 106.042 116.015 106.042H110.266C109.408 106.042 108.627 106.522 108.25 107.295L95.6709 132.452C95.5079 132.761 95.4307 133.113 95.4307 133.456V160.218C95.4307 160.818 95.6709 161.385 96.0914 161.814L104.183 169.905C104.603 170.325 105.178 170.566 105.779 170.566H169.35V190.729H153.184",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.75 125.29H109.727C110.731 125.29 111.554 126.114 111.554 127.118V144.536C111.554 145.539 110.731 146.363 109.727 146.363H104.484",
    fill: "url(#paint2_linear_3293_34496)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.75 125.29H109.727C110.731 125.29 111.554 126.114 111.554 127.118V144.536C111.554 145.539 110.731 146.363 109.727 146.363H104.484",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.304 163.53V132.898H127.684V168.661",
    fill: "url(#paint3_linear_3293_34496)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.304 163.53V132.898H127.684V168.661",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4503 185.34H83.3193V193.405H99.4503V185.34Z",
    fill: "url(#paint4_radial_3293_34496)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6881 190.706C87.057 190.706 87.3574 190.405 87.3574 190.036C87.3574 189.667 87.057 189.367 86.6881 189.367C86.3191 189.367 86.0188 189.667 86.0188 190.036C86.0188 190.405 86.3191 190.706 86.6881 190.706Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0936 190.706C96.4626 190.706 96.7629 190.405 96.7629 190.036C96.7629 189.667 96.4626 189.367 96.0936 189.367C95.7247 189.367 95.4243 189.667 95.4243 190.036C95.4243 190.405 95.7247 190.706 96.0936 190.706Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M153.212 185.34H137.081V193.405H153.212V185.34Z",
    fill: "url(#paint5_radial_3293_34496)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140.442 190.706C140.811 190.706 141.111 190.405 141.111 190.036C141.111 189.667 140.811 189.367 140.442 189.367C140.073 189.367 139.772 189.667 139.772 190.036C139.772 190.405 140.073 190.706 140.442 190.706Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M149.854 190.706C150.223 190.706 150.523 190.405 150.523 190.036C150.523 189.667 150.223 189.367 149.854 189.367C149.485 189.367 149.185 189.667 149.185 190.036C149.185 190.405 149.485 190.706 149.854 190.706Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M169.35 85.1943H160.744V169.761H169.35V85.1943Z",
    fill: "url(#paint6_linear_3293_34496)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    width: 102,
    height: 30,
    rx: 15,
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M131.508 11.98V14.08H134.328V15.412H131.508V17.632H134.688V19H129.828V10.612H134.688V11.98H131.508ZM139.887 19L138.519 16.936L137.307 19H135.507L137.679 15.664L135.483 12.352H137.379L138.735 14.404L139.959 12.352H141.759L139.575 15.664L141.783 19H139.887ZM144.651 13.732V16.948C144.651 17.172 144.703 17.336 144.807 17.44C144.919 17.536 145.103 17.584 145.359 17.584H146.139V19H145.083C143.667 19 142.959 18.312 142.959 16.936V13.732H142.167V12.352H142.959V10.708H144.651V12.352H146.139V13.732H144.651ZM149.028 13.384C149.244 13.032 149.524 12.756 149.868 12.556C150.22 12.356 150.62 12.256 151.068 12.256V14.02H150.624C150.096 14.02 149.696 14.144 149.424 14.392C149.16 14.64 149.028 15.072 149.028 15.688V19H147.348V12.352H149.028V13.384ZM158.475 12.352V19H156.783V18.16C156.567 18.448 156.283 18.676 155.931 18.844C155.587 19.004 155.211 19.084 154.803 19.084C154.283 19.084 153.823 18.976 153.423 18.76C153.023 18.536 152.707 18.212 152.475 17.788C152.251 17.356 152.139 16.844 152.139 16.252V12.352H153.819V16.012C153.819 16.54 153.951 16.948 154.215 17.236C154.479 17.516 154.839 17.656 155.295 17.656C155.759 17.656 156.123 17.516 156.387 17.236C156.651 16.948 156.783 16.54 156.783 16.012V12.352H158.475ZM159.701 15.652C159.701 14.98 159.833 14.384 160.097 13.864C160.369 13.344 160.737 12.944 161.201 12.664C161.665 12.384 162.181 12.244 162.749 12.244C163.181 12.244 163.593 12.34 163.985 12.532C164.377 12.716 164.689 12.964 164.921 13.276V10.12H166.625V19H164.921V18.016C164.713 18.344 164.421 18.608 164.045 18.808C163.669 19.008 163.233 19.108 162.737 19.108C162.177 19.108 161.665 18.964 161.201 18.676C160.737 18.388 160.369 17.984 160.097 17.464C159.833 16.936 159.701 16.332 159.701 15.652ZM164.933 15.676C164.933 15.268 164.853 14.92 164.693 14.632C164.533 14.336 164.317 14.112 164.045 13.96C163.773 13.8 163.481 13.72 163.169 13.72C162.857 13.72 162.569 13.796 162.305 13.948C162.041 14.1 161.825 14.324 161.657 14.62C161.497 14.908 161.417 15.252 161.417 15.652C161.417 16.052 161.497 16.404 161.657 16.708C161.825 17.004 162.041 17.232 162.305 17.392C162.577 17.552 162.865 17.632 163.169 17.632C163.481 17.632 163.773 17.556 164.045 17.404C164.317 17.244 164.533 17.02 164.693 16.732C164.853 16.436 164.933 16.084 164.933 15.676ZM174.446 15.532C174.446 15.772 174.43 15.988 174.398 16.18H169.538C169.578 16.66 169.746 17.036 170.042 17.308C170.338 17.58 170.702 17.716 171.134 17.716C171.758 17.716 172.202 17.448 172.466 16.912H174.278C174.086 17.552 173.718 18.08 173.174 18.496C172.63 18.904 171.962 19.108 171.17 19.108C170.53 19.108 169.954 18.968 169.442 18.688C168.938 18.4 168.542 17.996 168.254 17.476C167.974 16.956 167.833 16.356 167.833 15.676C167.833 14.988 167.974 14.384 168.254 13.864C168.534 13.344 168.926 12.944 169.43 12.664C169.934 12.384 170.514 12.244 171.17 12.244C171.802 12.244 172.366 12.38 172.862 12.652C173.366 12.924 173.754 13.312 174.026 13.816C174.306 14.312 174.446 14.884 174.446 15.532ZM172.706 15.052C172.698 14.62 172.542 14.276 172.238 14.02C171.934 13.756 171.562 13.624 171.122 13.624C170.706 13.624 170.354 13.752 170.066 14.008C169.786 14.256 169.614 14.604 169.55 15.052H172.706ZM177.352 13.384C177.568 13.032 177.848 12.756 178.192 12.556C178.544 12.356 178.944 12.256 179.392 12.256V14.02H178.948C178.42 14.02 178.02 14.144 177.748 14.392C177.484 14.64 177.352 15.072 177.352 15.688V19H175.672V12.352H177.352V13.384ZM192.515 10.624V19H190.835V13.552L188.591 19H187.319L185.063 13.552V19H183.383V10.624H185.291L187.955 16.852L190.619 10.624H192.515ZM197.128 19.108C196.488 19.108 195.912 18.968 195.4 18.688C194.888 18.4 194.484 17.996 194.188 17.476C193.9 16.956 193.756 16.356 193.756 15.676C193.756 14.996 193.904 14.396 194.2 13.876C194.504 13.356 194.916 12.956 195.436 12.676C195.956 12.388 196.536 12.244 197.176 12.244C197.816 12.244 198.396 12.388 198.916 12.676C199.436 12.956 199.844 13.356 200.14 13.876C200.444 14.396 200.596 14.996 200.596 15.676C200.596 16.356 200.44 16.956 200.128 17.476C199.824 17.996 199.408 18.4 198.88 18.688C198.36 18.968 197.776 19.108 197.128 19.108ZM197.128 17.644C197.432 17.644 197.716 17.572 197.98 17.428C198.252 17.276 198.468 17.052 198.628 16.756C198.788 16.46 198.868 16.1 198.868 15.676C198.868 15.044 198.7 14.56 198.364 14.224C198.036 13.88 197.632 13.708 197.152 13.708C196.672 13.708 196.268 13.88 195.94 14.224C195.62 14.56 195.46 15.044 195.46 15.676C195.46 16.308 195.616 16.796 195.928 17.14C196.248 17.476 196.648 17.644 197.128 17.644ZM203.784 13.732V16.948C203.784 17.172 203.836 17.336 203.94 17.44C204.052 17.536 204.236 17.584 204.492 17.584H205.272V19H204.216C202.8 19 202.092 18.312 202.092 16.936V13.732H201.3V12.352H202.092V10.708H203.784V12.352H205.272V13.732H203.784ZM209.432 19.108C208.792 19.108 208.216 18.968 207.704 18.688C207.192 18.4 206.788 17.996 206.492 17.476C206.204 16.956 206.06 16.356 206.06 15.676C206.06 14.996 206.208 14.396 206.504 13.876C206.808 13.356 207.22 12.956 207.74 12.676C208.26 12.388 208.84 12.244 209.48 12.244C210.12 12.244 210.7 12.388 211.22 12.676C211.74 12.956 212.148 13.356 212.444 13.876C212.748 14.396 212.9 14.996 212.9 15.676C212.9 16.356 212.744 16.956 212.432 17.476C212.128 17.996 211.712 18.4 211.184 18.688C210.664 18.968 210.08 19.108 209.432 19.108ZM209.432 17.644C209.736 17.644 210.02 17.572 210.284 17.428C210.556 17.276 210.772 17.052 210.932 16.756C211.092 16.46 211.172 16.1 211.172 15.676C211.172 15.044 211.004 14.56 210.668 14.224C210.34 13.88 209.936 13.708 209.456 13.708C208.976 13.708 208.572 13.88 208.244 14.224C207.924 14.56 207.764 15.044 207.764 15.676C207.764 16.308 207.92 16.796 208.232 17.14C208.552 17.476 208.952 17.644 209.432 17.644ZM215.813 13.384C216.029 13.032 216.309 12.756 216.653 12.556C217.005 12.356 217.405 12.256 217.853 12.256V14.02H217.409C216.881 14.02 216.481 14.144 216.209 14.392C215.945 14.64 215.813 15.072 215.813 15.688V19H214.133V12.352H215.813V13.384Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M158.5 35L155.469 29.75L161.531 29.75L158.5 35Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3293_34496",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.107 133.528) scale(299.019 34.8101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3293_34496",
    x1: 103.487,
    y1: 136.27,
    x2: 115.576,
    y2: 136.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3293_34496",
    x1: 104.484,
    y1: 135.835,
    x2: 111.546,
    y2: 135.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3293_34496",
    x1: 122.304,
    y1: 150.78,
    x2: 127.676,
    y2: 150.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3293_34496",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.3848 189.373) scale(6.37515 6.37513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3293_34496",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.155 189.373) scale(6.37515 6.37513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3293_34496",
    x1: 160.744,
    y1: 127.478,
    x2: 169.341,
    y2: 127.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BDB8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A7A3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B1AEAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A7A3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtruderMotor);
export default __webpack_public_path__ + "static/media/ExtruderMotor.94b068659656002278868175c2228028.svg";
export { ForwardRef as ReactComponent };